import BasePageOverlay from "./BasePageOverlay.vue";

export default BasePageOverlay;
